<template>
	<div class="flex flex-col items-center">
		<div class="flex space-s-3" dir="ltr">
			<input
				v-for="(_, index) in otp"
				:key="index"
				:ref="(el: any) => (inputRefs[index] = el)"
				type="text"
				inputmode="numeric"
				maxlength="1"
				:value="otp[index]"
				class="border-gray-300 h-12 w-10 rounded-lg border-2 text-center text-xl font-bold text-slate-950 transition-all focus:border-company focus:outline-none md:h-14 md:w-12 md:text-2xl"
				@input="handleInput(index, $event)"
				@keydown="handleKeyDown(index, $event)"
				@paste="handlePaste($event)"
			/>
		</div>
	</div>
</template>
<script setup lang="ts">
const emit = defineEmits<{
	"update:modelValue": [string]
	done: []
}>()

const props = defineProps<{
	modelValue?: string
	length: number
}>()

const otp = ref(["", "", "", "", "", ""])
const inputRefs = ref<HTMLInputElement[]>([])

const isComplete = computed(() => {
	return otp.value.every((digit) => digit !== "")
})

const handleInput = (index: number, event: any) => {
	const value = event.target.value

	if (!/^\d*$/.test(value)) {
		event.target.value = otp.value[index]
		return
	}

	otp.value[index] = value.slice(-1)

	if (value && index < 5) {
		inputRefs.value[index + 1]?.focus()
	}
}

const handleKeyDown = (index: number, event: any) => {
	if (event.key === "Backspace" && !otp.value[index] && index > 0) {
		inputRefs.value[index - 1]?.focus()
	}
}

const handlePaste = (event: any) => {
	event.preventDefault()
	const pastedData = String(event.clipboardData.getData("text")).slice(0, 6)

	if (!/^\d+$/.test(pastedData)) return

	pastedData.split("").forEach((char, index) => {
		if (index < 6) otp.value[index] = char
	})

	const nextIndex = Math.min(pastedData.length, 5)
	inputRefs.value[nextIndex]?.focus()
}

watch(
	isComplete,
	(n) => {
		if (n) emit("update:modelValue", otp.value.join(""))
	},
	{ immediate: true }
)

watch(
	() => props.modelValue,
	(n, o) => {
		if (o == n || !n) return
		n.split("").forEach((char, index) => {
			if (index < 6) otp.value[index] = char
		})
		if (n) {
			emit("update:modelValue", otp.value.join(""))
			emit("done")
		}
	},
	{ immediate: true }
)
</script>
